var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-element w-100",attrs:{"id":"payment-element"}})
}
var staticRenderFns = []

export { render, staticRenderFns }